

import Component from 'generic.basecomponent';
import constants from 'general/js/constants';
import Spinbox from '../../spinbox/js/generic.spinbox';
import FormValidityHandler from '../../form/js/form-validity-handler';


export default class EventOptions extends Component {
    constructor(el) {
        super(el);
        this.itemSelector = '.js-event-options__item';
        this.radioSelector = '.js-event-options__radio';
        this.spinboxSelector = '.js-event-options__spinox';
        this.hiddenCounterSelector = '.js-event-options__hidden-counter';

        this.itemChangeHandler = this.itemChangeHandler.bind(this);
        this.onSpinboxValueChanged = this.onSpinboxValueChanged.bind(this);

        this.init();
    }

    init() {
        this.items = [...this.container.querySelectorAll(this.itemSelector)];
        this.radioButtons = [...this.container.querySelectorAll(this.radioSelector)];
        this.spinboxInstances = [];
        this.spinboxContainers = [];
        this.invalidSpinboxFields = [];
        this.items.forEach((item, i) => {
            item.addEventListener('change', this.itemChangeHandler);
            item.addEventListener(constants.EVENT_SPINBOX_CHANGED, this.onSpinboxValueChanged);
            const spinboxNode = item.querySelector(this.spinboxSelector);
            if (spinboxNode) {
                this.spinboxInstances[i] = new Spinbox(spinboxNode);
                this.spinboxContainers[i] = spinboxNode;
                new FormValidityHandler({
                    element: spinboxNode,
                    onFailed: this.onInnerFieldNotValid.bind(this, i),
                });
            }
        });

        this.hiddenCounter = this.container.querySelector(this.hiddenCounterSelector);

        this.setInintialActive();
    }

    onInnerFieldNotValid(i, event) {
        if (event.field) {
            this.invalidSpinboxFields[i] = event.field;
        }
    }


    itemChangeHandler(e) {
        const target = e.target;
        if (target.matches(this.radioSelector)) {
            this.radioChangeHandler(e);
        }
    }

    radioChangeHandler(e) {
        this.setActive(e.currentTarget);
    }

    setActive(itemNode) {
        this.items.forEach((item, i) => {
            if (itemNode === item) {
                item.classList.add('is-active');

                if (this.spinboxContainers[i]) {
                    this.spinboxContainers[i].removeAttribute('data-validate-never');
                    this.spinboxContainers[i].setAttribute('data-validate-always', '');
                    this.spinboxInstances[i].enable();
                }
            } else {
                item.classList.remove('is-active');

                if (this.spinboxInstances[i]) {
                    this.spinboxInstances[i].setToMin();
                    this.spinboxInstances[i].disable();
                }

                if (this.spinboxContainers[i]) {
                    this.spinboxContainers[i].removeAttribute('data-validate-always');
                    this.spinboxContainers[i].setAttribute('data-validate-never', '');
                }

                if (this.invalidSpinboxFields[i]) {
                    this.invalidSpinboxFields[i].reset();
                }
            }
        });
    }

    setInintialActive() {
        this.radioButtons.forEach((input, i) => {
            if (input.checked) {
                this.items[i].classList.add('is-active');
                if (this.spinboxInstances[i]) {
                    this.spinboxInstances[i].enable();
                }

                if (this.spinboxContainers[i]) {
                    this.spinboxContainers[i].setAttribute('data-validate-always', '');
                }
            } else if (this.spinboxContainers[i]) {
                this.spinboxContainers[i].setAttribute('data-validate-never', '');
                this.spinboxInstances[i].disable();
            }
        });
    }

    onSpinboxValueChanged(e) {
        this.hiddenCounter.value = e.target.value;
    }

    destroy() {
        super.destroy();

        this.items.forEach((item) => {
            item.removeEventListener('change', this.itemChangeHandler);
        });
        this.spinboxInstances.forEach((spinbox) => {
            if (spinbox) {
                spinbox.destroy();
            }
        });
        this.container.classList.remove('js-event-options-inited');
    }
}



// WEBPACK FOOTER //
// ./app/components/event-options/js/generic.event-options.js